export const setUserName = (state, userName) => {
  state.userName = userName;
};

export const setSoundFlag = (state, flag) => {
  state.soundFlag = flag;
};

export const setIsAnimBg = (state, flag) => {
  state.isAnimBg = flag;
};

export const setBgNumber = (state, num) => {
  state.bgNumber = num;
};

export const setIsMovieActive = (state, flag) => {
  state.isMovieActive = flag;
};
